import React, { useEffect, useState } from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Dropdown from "react-bootstrap/Dropdown";
import Image from "react-bootstrap/Image";
import MainWrapper from "../layouts/MainWrapper";
import CardWrapper from "../layouts/CardWrapper";
import PageTitle from "../components/PageTitle";
import CustomBreadcrumb from "../components/CustomBreadcrumb";
import DataTable from "../components/Table/Table";
import HistoryDetailsPanel from "../components/DetailsPanel/HistoryDetailsPanel";
import TablePagination from "../components/TablePagination/TablePagination";
import ImagePreviewLightbox from "../components/ImagePreviewLightbox";
import { getHistory, listHistoryUser } from "../services/historyServices";
import { useAlert } from "../contexts/AlertContext";
import { listExpertUsers, singleUser } from "../services/userService";
import AllFile from "./AllFiles";
import { getChatFiles } from "../services/chatServices";
import { useAtomValue } from "jotai";
import { authAtom } from "../states/auth";
import useDebounce from "../utils/useDebounce";
import moment from "moment";

const formatDate = (date) => {
  if (!date) return new Date();

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const year = date.getFullYear();

  return `${month}-${day}-${year}`;
};

function getFileOwner(userId, userObject, conversationMembers = []) {
  console.log("userObn", userObject);

  // Step 1: Try to find user in conversation members
  const matchedMember = conversationMembers.find(
    (member) => member.user_id === userId,
  );
  if (matchedMember) {
    return `${matchedMember.user.firstName || ""} ${
      matchedMember.user.lastName || ""
    }`.trim();
  }

  // Step 2: Check if userId matches createdBy
  if (userObject?.id === userId) {
    return `${userObject.firstName || ""} ${userObject.lastName || ""}`.trim();
  }

  // Step 3: Fallback to createdBy user's name if present
  if (userObject) {
    return `${userObject.firstName || ""} ${userObject.lastName || ""}`.trim();
  }

  // Step 4: Nothing matched
  return "Unknown User";
}

const columns = [
  { label: "Date", key: "createdDate", sort: true },
  { label: "End Time", key: "createdDate", sort: true },
  { label: "Channel", key: "sessionType", sort: true },
  { label: "Company Name", key: "companyName", sort: true },
  { label: "Caller", key: "createdBy", sort: true },
  { label: "Receiver", key: "acceptedBy", sort: true },
  { label: "Expertise", key: "expertise.name", sort: true },
  { label: "Action", key: "expertise.name", sort: false },
];

const getThisMonthRange = () => {
  const now = new Date();
  const start = new Date(now.getFullYear(), now.getMonth(), 1);
  const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  return { from: start, to: end };
};

const identifyUser = (data, auth) => {
  let userMeta = { label: "", image: "", role: "" };
  if (data?.createdBy?.roleId == 3) {
    if (data?.conversationType == "internal call") {
      userMeta = {
        label: "Expert",
        role: "expert",
        image: "/images/user-circle-yellow.svg",
      };
    } else if (data?.createdBy?.createdBy.id !== auth) {
      userMeta = {
        label: "Contact",
        role: "client",
        image: "/images/user-circle-gear-blue.svg",
      };
    } else {
      userMeta = {
        label: "External Expert",
        role: "external_expert",
        image: "/images/user-circle-dashed-red.svg",
      };
    }
  } else if (data?.createdBy?.roleId == 5) {
    userMeta = {
      label: "Contact",
      role: "client",
      image: "/images/user-circle-gear-blue.svg",
    };
  } else if (data?.createdBy?.roleId == 2) {
    if (data?.createdBy?.createdBy === data?.createdBy?.id) {
      userMeta = {
        label: "User",
        role: "internal_user",
        image: "/images/user-circle-yellow.svg",
      };
    } else {
      userMeta = {
        label: "User",
        role: "external_user",
        image: "/images/user-circle-yellow.svg",
      };
    }
  }
  return userMeta;
};

const History = () => {
  const [filesPagination, setFilesPagination] = useState({
    limit: 10,
    nextToken: null,
  });
  const [selectedItem, setSelectedItem] = useState(null);
  const [historyUserList, setHistoryUserList] = useState(null);
  const initialRange = getThisMonthRange();
  const [files, setFiles] = useState(null);
  const [showFilesView, setShowFilesView] = useState(false);
  const [showStatusTypeDropdown, setStatusTypeDropdown] = useState(false);
  const [tempUserIDs, setTempUserIDs] = useState([]);
  const [tempSessionType, setTempSessionType] = useState("all");
  const [range, setRange] = useState(initialRange);
  const [historyList, setHistoryList] = useState(null);
  const [showStatusDropdown, setShowStatusDropdown] = useState(false);
  const [showUsersDropdown, setShowUsersDropdown] = useState(false);
  const { showAlert } = useAlert();
  const [expertUsers, setExpertUsers] = useState([]);
  const [selectedPage, setSelectedPage] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [chatFiles, setChatFiles] = useState([]);
  const [chatFilesTotal, setChatFilesTotal] = useState();
  const [totalResults, setTotalResults] = useState(0);
  const [currentConversationId, setCurrentConversationId] = useState(null);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [search, setSearch] = useState("");
  const [loginUserId, setLoginUserId] = useState(null);
  const [userSearchFilter, setUserSearchFilter] = useState({
    search: "",
  });
  const [filter, setFilter] = useState({
    no_of_result: 10,
    page: 1,
    search: "",
    startDate: null,
    endDate: null,
    userIDs: [],
    sessionType: "all",
  });
  const [searchFlag, setSearchFlag] = useState(false);
  const debouncedSearchTerm = useDebounce(filter, searchFlag ? 500 : 0);
  const auth = useAtomValue(authAtom);
  console.log("loginUserId", loginUserId);
  const toUTCStartOfDay = (date) => {
    if (!date) return null;
    // Take local midnight (IST), then convert to UTC
    const start = new Date(date);
    start.setHours(0, 0, 0, 0);
    return start.toISOString();
  };

  const toUTCEndOfDay = (date) => {
    if (!date) return null;
    // Take local 23:59:59.999 (IST), then convert to UTC
    const end = new Date(date);
    end.setHours(23, 59, 59, 999);
    return end.toISOString();
  };

  const rowHandler = (item) => {
    if (currentConversationId !== item?.id) {
      setChatFiles([]);
      setFilesPagination({ limit: 10, nextToken: null });
      setHasMore(true);
      setCurrentConversationId(item?.id);
    }

    setSelectedItem(item);
    document.body.classList.add("sidebar-collapsed");
  };

  useEffect(() => {
    singleUser(auth?.user?.id).then((response) => {
      if (response?.data?.user) {
        const UserData = response?.data?.user;
        let loginUserId =
          UserData?.roleId === 2 ? UserData?.id : UserData?.createdBy?.id;
        setLoginUserId(loginUserId);
      }
    });
  }, [auth?.user]);

  const filterFilesByType = (message) => {
    let type;
    console.log("message", message);

    switch (message.message_type) {
      case 3:
        type = { text: "Image", className: "badge-warning" };
        break;
      case 4:
        type = { text: "Video", className: "badge-danger" };
        break;
      case 5:
        type = { text: "Audio", className: "badge-secondary" };
        break;
      default:
        type = { text: "Document", className: "badge-success" };
    }
    return type;
  };

  const getFiles = async (conversationId, next = null) => {
    if (isLoadingMore) return;
    setIsLoadingMore(true);

    try {
      const data = await getChatFiles(conversationId, {
        ...filesPagination,
        nextToken: next || filesPagination.nextToken,
      });

      const items = data?.data?.items || [];
      let finalData = [];

      if (items.length > 0) {
        // Sort items by created_date
        items.sort(
          (a, b) => new Date(a.created_date) - new Date(b.created_date),
        );

        // Map chat items
        finalData = items.map((element) => {
          const parts = element?.message.split("/");
          const filename = parts[parts.length - 1];
          const badge = filterFilesByType(element);
          const owner = getFileOwner(
            element.sender_id,
            selectedItem?.createdBy,
            selectedItem?.conversationMembers,
          );
          return { ...element, name: filename, badge, owner };
        });
      }

      // ---- Map transcripts ----
      const mappedTranscripts = (data?.data?.transcripts || []).map((item) => {
        const url = item.url;
        const filename = url.split("/").pop();
        return {
          id: `transcript-${item.id}`,
          message_type: 7,
          message: url,
          name: filename,
          badge: filterFilesByType({ message_type: 7 }),
          owner: "System",
          created_date: item.created_date,
        };
      });

      // ---- Map recordings ----
      const mappedRecordings = (data?.data?.recordings || []).map((item) => {
        const url = item.url;
        const filename = url.split("/").pop();
        return {
          id: `recording-${item.id}`,
          message_type: 4,
          message: url,
          name: filename,
          badge: filterFilesByType({ message_type: 4 }),
          owner: "System",
          created_date: item.created_date,
        };
      });

      // ---- Map screenshots ----
      const mappedScreenshots = (data?.data?.screenshotImages || []).map(
        (item) => {
          const url = item.url;
          const filename = url.split("/").pop();
          return {
            id: `screenshot-${item.id}`,
            message_type: 3,
            message: url,
            name: filename,
            badge: { text: "Screenshot", className: "badge-primary" },
            owner: "System",
            created_date: item.created_date,
          };
        },
      );

      // ---- Update state ----
      setChatFiles((prev) => [
        ...prev,
        ...finalData,
        ...mappedTranscripts,
        ...mappedScreenshots,
        ...mappedRecordings,
      ]);

      // ---- Handle pagination ----
      const token = data?.data?.nextToken;
      if (token) {
        setFilesPagination((prev) => ({ ...prev, nextToken: token }));
        setHasMore(true);
      } else {
        setHasMore(false);
      }
    } catch (error) {
      showAlert({
        title: "Chat Screen Notification",
        message: error?.response?.data?.message ?? "Something went wrong",
        variant: "danger",
      });
    } finally {
      setIsLoadingMore(false);
    }
  };

  const filteredUsers = historyUserList?.filter((user) => {
    if (!search?.trim()) return true;

    const fullName =
      `${user?.firstName ?? ""} ${user?.lastName ?? ""}`.toLowerCase();

    return fullName.includes(search.trim().toLowerCase());
  });

  // useEffect(() => {
  //   if (currentConversationId && chatFiles.length === 0) {
  //     getFiles(currentConversationId);
  //   }
  // }, [currentConversationId]);
  useEffect(() => {
    if (currentConversationId && hasMore) {
      getFiles(currentConversationId);
    }
  }, [filesPagination.nextToken, currentConversationId]);

  const getHistoryData = async () => {
    try {
      const { sessionType, ...rest } = filter;
      const data = await getHistory({ ...rest, filter: sessionType });
      setHistoryList(data?.data);
      setTotalResults(data?.totalResult);
    } catch (error) {
      console.error("Error fetching invitees:", error);
      showAlert({
        title: "Contact Access Notification",
        message: error?.response?.data?.message ?? "something went wrong",
        variant: "danger",
      });
    }
  };

  const getHistoryUsersData = async () => {
    try {
      const data = await listHistoryUser(userSearchFilter);
      setHistoryUserList(data?.data);
    } catch (error) {
      console.error("Error fetching invitees:", error);
      showAlert({
        title: "Contact Access Notification",
        message: error?.response?.data?.message ?? "something went wrong",
        variant: "danger",
      });
    }
  };

  useEffect(() => {
    getHistoryUsersData();
  }, []);

  useEffect(() => {
    if (debouncedSearchTerm) {
      console.log("Performing search for:", debouncedSearchTerm);
      // In a real application, you would make an API call here
      getHistoryData();
      setSearchFlag(false);
    } else {
      console.log("Search term cleared.");
    }
  }, [debouncedSearchTerm]);

  useEffect(() => {
    // if (range?.from || range?.to) {
    setHistoryList(null);
    setSelectedPage(1);
    setFilter((prev) => ({
      ...prev,
      startDate: toUTCStartOfDay(range?.from),
      endDate: toUTCEndOfDay(range?.to),
    }));

    // }
    console.log("filterAaA", filter);
  }, [range]);

  useEffect(() => {
    if (historyList && historyList.length > 0 && !selectedItem) {
      const firstItem = historyList[0];
      rowHandler(firstItem);
    }
  }, [historyList]);

  const changeFilterCriteriaByName = (name, value) => {
    console.log(name, value);
    if (name === "search") {
      setSelectedPage(1);
      setSearchFlag(true);
    }
    filter[name] = value;

    setHistoryList(null);
    setFilter({ ...filter });
  };

  useEffect(() => {
    changeFilterCriteriaByName("page", selectedPage);
  }, [selectedPage]);

  const BeadcrumbItems = [{ label: "History", active: true }];
  const sessionLabelMap = {
    all: "All Sessions",
    client: "Received",
    internal: "Internal",
    experts: "Requested",
  };
  useEffect(() => {
    if (historyUserList?.length > 0) {
      setTempUserIDs(historyUserList.map((user) => user.id));
    }
  }, [historyUserList]);

  const selectedLabel = (() => {
    if (tempUserIDs.length === historyUserList?.length) {
      return "All Team Members";
    }
    if (tempUserIDs.length === 1) {
      const user = historyUserList.find((u) => u.id === tempUserIDs[0]);
      return user ? `${user.firstName} ${user.lastName}` : "1 Selected";
    }

    if (tempUserIDs.length > 1) {
      return `${tempUserIDs.length} Selected`;
    }
    return "All Team Members";
  })();

  return (
    <>
      {(!showFilesView && (
        <>
          <div className="mb-4">
            <CustomBreadcrumb items={BeadcrumbItems} />
            <PageTitle title="History" />
          </div>
          <MainWrapper>
            <CardWrapper>
              <Row className="align-items-center gy-4 gy-lg-0 mb-4">
                <Col lg="2">
                  <div class="d-flex align-items-center gap-4">
                    <h2 className="fs-5 fw-semibold text-gray-800 mb-0">
                      Sessions
                    </h2>
                  </div>
                </Col>
                <Col className="flex-grow-1 text-end">
                  <Row className="align-items-center justify-content-md-end gy-3 gy-lg-0 gx-2">
                    <Col className="flex-grow-1">
                      <Dropdown
                        show={showUsersDropdown}
                        onToggle={(isOpen) => setShowUsersDropdown(isOpen)}
                      >
                        {auth.user.roleId === 2 && (
                          <Dropdown.Toggle
                            variant="light"
                            className="filter-dropdown-button dropdown-toggle-arrow"
                            align="end"
                          >
                            {selectedLabel}
                          </Dropdown.Toggle>
                        )}
                        <Dropdown.Menu
                          className="filter-dropdown-menu dropdown-menu-end p-0"
                          align="end"
                          popperConfig={{
                            modifiers: [
                              {
                                name: "offset",
                                options: { offset: [0, 5] },
                              },
                            ],
                          }}
                        >
                          <div className="filter-dropdown-menu-list p-2 border-bottom">
                            <input
                              className="form-control form-control-search"
                              aria-label="Search Input"
                              placeholder="Search here..."
                              autoComplete="off"
                              type="text"
                              value={search}
                              onChange={(e) => setSearch(e.target.value)}
                            />
                          </div>
                          <div className="px-3 pt-2 border-bottom">
                            <Form.Check
                              className="checkbox-primary mb-2"
                              type="checkbox"
                              label="Select All"
                              id="checkbox-all"
                              checked={
                                filteredUsers?.length > 0 &&
                                filteredUsers.every((user) =>
                                  tempUserIDs.includes(user.id),
                                )
                              }
                              onChange={(e) => {
                                const newUsers = e.target.checked
                                  ? [
                                      ...new Set([
                                        ...tempUserIDs,
                                        ...filteredUsers.map((user) => user.id),
                                      ]),
                                    ]
                                  : tempUserIDs.filter(
                                      (id) =>
                                        !filteredUsers.some(
                                          (user) => user.id === id,
                                        ),
                                    );
                                setTempUserIDs(newUsers);
                              }}
                            />
                          </div>
                          <div className="filter-dropdown-menu-list px-3 py-2 border-bottom">
                            {filteredUsers?.map((expert, index) => {
                              return (
                                <Form.Check
                                  key={expert?.id}
                                  className="checkbox-primary mb-2"
                                  type="checkbox"
                                  label={
                                    expert.firstName + " " + expert.lastName
                                  }
                                  id={`user-${expert.id}`}
                                  name="users"
                                  checked={tempUserIDs?.includes(expert.id)}
                                  onChange={(e) => {
                                    const updatedUsers = e.target.checked
                                      ? [...tempUserIDs, expert.id]
                                      : tempUserIDs?.filter(
                                          (id) => id !== expert.id,
                                        );
                                    setTempUserIDs(updatedUsers);
                                  }}
                                />
                              );
                            })}
                          </div>
                          <div className="px-3 py-2 d-flex align-items-center justify-content-between">
                            <button
                              className="btn btn-sm btn-reset text-blue"
                              onClick={() => {
                                const allUserIds =
                                  historyUserList?.map((user) => user.id) || [];
                                setTempUserIDs(allUserIds);
                                setShowUsersDropdown(false);
                                setHistoryList(null);
                                setFilter({
                                  ...filter,
                                  userIDs: allUserIds,
                                });
                                setSelectedPage(1);
                              }}
                            >
                              Reset
                            </button>

                            <button
                              onClick={() => {
                                setShowUsersDropdown(false);

                                setHistoryList(null);
                                setFilter({
                                  ...filter,
                                  userIDs: tempUserIDs,
                                });
                                setSelectedPage(1);
                              }}
                              className="btn btn-sm btn-blue"
                            >
                              Okay
                            </button>
                          </div>
                        </Dropdown.Menu>
                      </Dropdown>
                    </Col>
                    <Col className="flex-grow-1">
                      <Dropdown
                        show={showStatusTypeDropdown}
                        onToggle={(isOpen) => setStatusTypeDropdown(isOpen)}
                      >
                        <Dropdown.Toggle
                          variant="light"
                          className="filter-dropdown-button form-control dropdown-toggle-arrow w-100 text-start"
                          align="end"
                        >
                          {sessionLabelMap[tempSessionType] || "All Sessions"}
                        </Dropdown.Toggle>

                        <Dropdown.Menu
                          className="filter-dropdown-menu dropdown-menu-end p-0"
                          align="end"
                          popperConfig={{
                            modifiers: [
                              {
                                name: "offset",
                                options: { offset: [0, 5] },
                              },
                            ],
                          }}
                        >
                          <div className="px-3 pt-2 border-bottom">
                            <Form.Check
                              className="radio-primary mb-3"
                              type="radio"
                              label="Select All"
                              value="all"
                              checked={tempSessionType === "all"}
                              onChange={() => setTempSessionType("all")}
                              id="radio-all"
                            />
                          </div>
                          <div className="px-4 pt-3 pb-2 border-bottom">
                            <Form.Check
                              className="radio-primary mb-3"
                              type="radio"
                              label="Received"
                              value="client"
                              onChange={() => setTempSessionType("client")}
                              checked={tempSessionType === "client"}
                              id="radio-clients"
                            />

                            <Form.Check
                              className="radio-primary mb-3"
                              type="radio"
                              label="Internal"
                              value="internal"
                              onChange={() => setTempSessionType("internal")}
                              checked={tempSessionType === "internal"}
                              id="radio-internal-users"
                            />
                            <Form.Check
                              className="radio-primary mb-3"
                              type="radio"
                              value="experts"
                              checked={tempSessionType === "experts"}
                              onChange={() => setTempSessionType("experts")}
                              label="Requested"
                              id="radio-external-experts"
                            />
                          </div>
                          <div className="p-2 d-flex align-items-center justify-content-between">
                            <button
                              className="btn btn-xm btn-reset text-blue"
                              onClick={(e) => {
                                e.stopPropagation(); // prevent dropdown toggling due to click
                                setTempSessionType("all");
                                changeFilterCriteriaByName(
                                  "sessionType",
                                  "all",
                                );
                              }}
                            >
                              Reset
                            </button>
                            <button
                              className="btn btn-xm btn-blue"
                              onClick={(e) => {
                                e.stopPropagation(); // prevent dropdown toggling due to click
                                setSelectedPage(1);
                                changeFilterCriteriaByName(
                                  "sessionType",
                                  tempSessionType,
                                );
                                setStatusTypeDropdown(false); // close the dropdown
                              }}
                            >
                              Okay
                            </button>
                          </div>
                        </Dropdown.Menu>
                      </Dropdown>
                    </Col>
                    <Col className="flex-grow-1">
                      <Dropdown align="end">
                        <Dropdown.Toggle
                          as="button"
                          id="to-date"
                          className="filter-dropdown-button form-control dropdown-toggle-calendar dropdown-toggle-none d-flex align-items-center justify-content-between gap-2 w-100"
                        >
                          <span
                            className="text-truncate"
                            title={`${formatDate(range?.from)} - ${formatDate(range?.to)}`}
                          >
                            {range?.from && range?.to
                              ? `${formatDate(range?.from)} - ${formatDate(
                                  range?.to,
                                )}`
                              : "From - To Date"}
                          </span>
                          <Image
                            src="/images/calendar-dots.svg"
                            alt="Calendar Check Icon"
                          />
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="calendar-dropdown-menu dropdown-menu dropdown-menu-end">
                          <DayPicker
                            mode="range"
                            selected={range}
                            defaultMonth={new Date()}
                            onSelect={(event) => (
                              console.log("datechange", event),
                              setRange(event)
                            )}
                            // onDayClick={() => setShowCalendar(false)}
                          />
                        </Dropdown.Menu>
                      </Dropdown>
                    </Col>
                    <Col lg="4">
                      <input
                        type="text"
                        name="search"
                        onChange={(e) =>
                          changeFilterCriteriaByName("search", e.target.value)
                        }
                        className="form-control form-control-search"
                        aria-label="Search Input"
                        placeholder="Search here.."
                        autoComplete="off"
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
              <DataTable>
                <thead>
                  <tr>
                    {columns.map((element) => {
                      return (
                        <th class="cursor-pointer">
                          <div className="d-flex align-items-center gap-1">
                            {element?.label}{" "}
                          </div>
                        </th>
                      );
                    })}

                    {/* <th class="cursor-pointer">
                  <div className="d-flex align-items-center gap-1">
                    Company Name{" "}
                    <img
                      width="20"
                      height="20"
                      alt="Sort Icon"
                      class="ms-1"
                      src="/images/caret-up-down.svg"
                    ></img>
                  </div>
                </th>
                <th class="cursor-pointer">
                  <div className="d-flex align-items-center gap-1">
                    Caller
                    <img
                      width="20"
                      height="20"
                      alt="Sort Icon"
                      class="ms-1"
                      src="/images/caret-up-down.svg"
                    ></img>
                  </div>
                </th>
                <th class="cursor-pointer">
                  <div className="d-flex align-items-center gap-1">
                    Expert
                    <img
                      width="20"
                      height="20"
                      alt="Sort Icon"
                      class="ms-1"
                      src="/images/caret-up-down.svg"
                    ></img>
                  </div>
                </th>
                <th class="cursor-pointer">
                  <div className="d-flex align-items-center gap-1">
                    Expertise
                    <img
                      width="20"
                      height="20"
                      alt="Sort Icon"
                      class="ms-1"
                      src="/images/caret-up-down.svg"
                    ></img>
                  </div>
                </th> */}
                    {/* <th width="8%">Actions</th> */}
                  </tr>
                </thead>
                <tbody>
                  {historyList?.map((element) => {
                    const userMeta = identifyUser(element, loginUserId);
                    const anoterhMember = element.conversationMembers.find(
                      (e) => e.user_id != element.createdBy.id,
                    );
                    return (
                      <tr>
                        <td
                          className={
                            selectedItem?.id === element?.id && "bg-gray-50"
                          }
                          onClick={(e) => rowHandler(element)}
                        >
                          {formatDate(new Date(element?.endTime))}
                        </td>
                        <td
                          className={
                            selectedItem?.id === element?.id && "bg-gray-50"
                          }
                          onClick={(e) => rowHandler(element)}
                        >
                          {moment(element?.endTime).format("hh:mm A")}
                        </td>
                        <td
                          className={
                            selectedItem?.id === element?.id && "bg-gray-50"
                          }
                          onClick={(e) => rowHandler(element)}
                        >
                          <ul className="d-flex flex-wrap align-content-center gap-2 list-unstyled mb-0">
                            {element?.conversationType?.includes("chat") ? (
                              <li className="session-type-badge d-flex align-items-center gap-2">
                                <Image
                                  src="/images/chats-circle.svg"
                                  width={20}
                                  height={20}
                                  alt="Chat Circle Icon"
                                />{" "}
                                Chat
                              </li>
                            ) : (
                              <li className="session-type-badge d-flex align-items-center gap-2">
                                <Image
                                  src="/images/video-camera-blue.svg"
                                  width={20}
                                  height={20}
                                  alt="Video Camera Blue Icon"
                                />{" "}
                                Video
                              </li>
                            )}
                          </ul>
                        </td>
                        <td
                          className={
                            selectedItem?.id === element?.id && "bg-gray-50"
                          }
                          onClick={(e) => rowHandler(element)}
                        >
                          <div className="d-flex align-items-center gap-2">
                            <ImagePreviewLightbox src={userMeta?.image}>
                              <Image
                                width="32"
                                height="32"
                                alt="User Circle Gear Icon"
                                src={userMeta?.image}
                              />
                            </ImagePreviewLightbox>
                            {element?.createdBy.roleId == 5 ? (
                              <span>
                                {element?.createdBy?.companyName || "N/A"}
                              </span>
                            ) : (
                              <span>
                                {element?.admin?.companyName || "N/A"}
                              </span>
                            )}
                          </div>
                        </td>
                        <td
                          className={
                            selectedItem?.id === element?.id && "bg-gray-50"
                          }
                          onClick={(e) => rowHandler(element)}
                        >
                          <div className="d-flex align-items-center gap-2">
                            {element.createdBy?.profilePic ? (
                              <ImagePreviewLightbox
                                className="user-avtar user-avtar-32"
                                src={element?.createdBy?.profilePic}
                              >
                                <Image
                                  width="32"
                                  height="32"
                                  alt="User Avatar"
                                  className="object-fit-cover rounded-circle"
                                  onError={(e) => {
                                    e.target.src = "/images/user-avatar-1.png";
                                  }}
                                  src={element?.createdBy?.profilePic}
                                />
                              </ImagePreviewLightbox>
                            ) : (
                              <Image
                                width={32}
                                height={32}
                                alt="User Avatar"
                                className="object-fit-cover rounded-circle"
                                src={`https://ui-avatars.com/api/?name=${element?.createdBy?.firstName}+${element?.createdBy?.lastName}&background=007bff&color=fff&size=100`}
                              />
                            )}

                            <span>
                              {element?.createdBy?.firstName}{" "}
                              {element?.createdBy?.lastName}
                            </span>
                          </div>
                        </td>
                        <td
                          className={
                            selectedItem?.id === element?.id && "bg-gray-50"
                          }
                          onClick={(e) => rowHandler(element)}
                        >
                          <div className="d-flex align-items-center gap-2">
                            {anoterhMember.user?.profilePic ? (
                              <ImagePreviewLightbox
                                className="user-avtar user-avtar-32"
                                src={anoterhMember?.user?.profilePic}
                              >
                                <Image
                                  width="32"
                                  height="32"
                                  alt="User Avatar"
                                  className="object-fit-cover rounded-circle"
                                  onError={(e) => {
                                    e.target.src = "/images/user-avatar-1.png";
                                  }}
                                  src={anoterhMember?.user?.profilePic}
                                />
                              </ImagePreviewLightbox>
                            ) : (
                              <Image
                                width={32}
                                height={32}
                                alt="User Avatar"
                                className="object-fit-cover rounded-circle"
                                src={`https://ui-avatars.com/api/?name=${anoterhMember?.user?.firstName}+${anoterhMember?.user?.lastName}&background=007bff&color=fff&size=100`}
                              />
                            )}
                            <span>
                              {anoterhMember?.user?.firstName}{" "}
                              {anoterhMember?.user?.lastName}
                            </span>
                          </div>
                        </td>
                        <td
                          className={
                            selectedItem?.id === element?.id && "bg-gray-50"
                          }
                          onClick={(e) => rowHandler(element)}
                        >
                          {element?.expertise?.name || "N/A"}
                        </td>
                        <td
                          className={
                            selectedItem?.id === element?.id
                              ? "bg-gray-50"
                              : "column-action-btn"
                          }
                        >
                          <div className="d-flex gap-2 align-items-center">
                            <button
                              type="button"
                              className="btn-reset btn btn-primary"
                              onClick={(e) => rowHandler(element)}
                            >
                              <Image
                                width="24"
                                height="24"
                                alt="Eye Icon"
                                src="/images/eye-primary.svg"
                              />
                            </button>

                            <button
                              type="button"
                              className="btn-reset btn btn-primary px-2"
                              onClick={() => {
                                rowHandler(element);
                                setShowFilesView(true);
                              }}
                            >
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M16.6922 5.18281L13.5672 2.05781C13.5091 1.99979 13.4402 1.95378 13.3643 1.92241C13.2884 1.89105 13.2071 1.87494 13.125 1.875H6.875C6.54348 1.875 6.22554 2.0067 5.99112 2.24112C5.7567 2.47554 5.625 2.79348 5.625 3.125V4.375H4.375C4.04348 4.375 3.72554 4.5067 3.49112 4.74112C3.2567 4.97554 3.125 5.29348 3.125 5.625V16.875C3.125 17.2065 3.2567 17.5245 3.49112 17.7589C3.72554 17.9933 4.04348 18.125 4.375 18.125H13.125C13.4565 18.125 13.7745 17.9933 14.0089 17.7589C14.2433 17.5245 14.375 17.2065 14.375 16.875V15.625H15.625C15.9565 15.625 16.2745 15.4933 16.5089 15.2589C16.7433 15.0245 16.875 14.7065 16.875 14.375V5.625C16.8751 5.5429 16.859 5.46159 16.8276 5.38572C16.7962 5.30985 16.7502 5.2409 16.6922 5.18281ZM13.125 16.875H4.375V5.625H10.3664L13.125 8.38359V14.9875C13.125 14.9922 13.125 14.9961 13.125 15C13.125 15.0039 13.125 15.0078 13.125 15.0125V16.875ZM15.625 14.375H14.375V8.125C14.3751 8.0429 14.359 7.96159 14.3276 7.88572C14.2962 7.80985 14.2502 7.7409 14.1922 7.68281L11.0672 4.55781C11.0091 4.49979 10.9402 4.45378 10.8643 4.42241C10.7884 4.39105 10.7071 4.37494 10.625 4.375H6.875V3.125H12.8664L15.625 5.88359V14.375ZM11.25 11.875C11.25 12.0408 11.1842 12.1997 11.0669 12.3169C10.9497 12.4342 10.7908 12.5 10.625 12.5H6.875C6.70924 12.5 6.55027 12.4342 6.43306 12.3169C6.31585 12.1997 6.25 12.0408 6.25 11.875C6.25 11.7092 6.31585 11.5503 6.43306 11.4331C6.55027 11.3158 6.70924 11.25 6.875 11.25H10.625C10.7908 11.25 10.9497 11.3158 11.0669 11.4331C11.1842 11.5503 11.25 11.7092 11.25 11.875ZM11.25 14.375C11.25 14.5408 11.1842 14.6997 11.0669 14.8169C10.9497 14.9342 10.7908 15 10.625 15H6.875C6.70924 15 6.55027 14.9342 6.43306 14.8169C6.31585 14.6997 6.25 14.5408 6.25 14.375C6.25 14.2092 6.31585 14.0503 6.43306 13.9331C6.55027 13.8158 6.70924 13.75 6.875 13.75H10.625C10.7908 13.75 10.9497 13.8158 11.0669 13.9331C11.1842 14.0503 11.25 14.2092 11.25 14.375Z"
                                  fill="#334155"
                                />
                              </svg>
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </DataTable>
              <TablePagination
                selectedPage={selectedPage}
                setSelectedPage={setSelectedPage}
                totalResults={totalResults}
                resultsPerPage={10}
              />
            </CardWrapper>
            <HistoryDetailsPanel
              item={selectedItem}
              isOpen={!!selectedItem}
              onClose={() => setSelectedItem(null)}
              setShowFilesView={setShowFilesView}
            />
          </MainWrapper>
        </>
      )) || (
        <AllFile
          files={chatFiles}
          conversationId={selectedItem}
          chatFilesTotal={chatFilesTotal}
          setShowFilesView={setShowFilesView}
        />
      )}
    </>
  );
};

export default History;
